import PropTypes from "prop-types"
import classnames from "classnames"
import parse from "html-react-parser"
import icon from "images/icons/arrow-right.svg?raw"
import styles from "./applet_limit_warning.module.scss"

const AppletLimitWarning = ({ className, user: { appletQuota }, onUpgrade }) => {
  const created = appletQuota.total - appletQuota.remaining
  const visible = appletQuota.remaining > 0

  if (!visible) return null

  if (className === "initial-step") {
    return (
      <div className={styles["applet-limit-bar"]}>
        <span className="body-caption">You&rsquo;re using {created} of {appletQuota.total} Applets.</span>
        <button type="button" className="button-tertiary button-outlined button-with-icon" onClick={onUpgrade}>
          Upgrade for more Applets
          <span className="button-icon">{parse(icon)}</span>
        </button>
      </div>
    )
  }

  return (
    <div className={classnames(styles["applet-limit-warning"], { [styles[className]]: !!className })}>
      You&rsquo;re using {created} of {appletQuota.total} Applets
    </div>
  )
}

AppletLimitWarning.propTypes = {
  user: PropTypes.shape({
    appletQuota: PropTypes.shape({
      total: PropTypes.number,
      remaining: PropTypes.number,
    }),
  }),
  className: PropTypes.string,
  onUpgrade: PropTypes.func,
}

export default AppletLimitWarning
